export const NAVIGATION_INTENT_EVENT = "vp:navigation-intent";

/**
 * Gives mounted editors a synchronous chance to cancel an in-app navigation.
 * This is used because the application currently uses BrowserRouter; React
 * Router's useBlocker/usePrompt APIs require a data router and throw here.
 */
export function requestInAppNavigation(detail = {}) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return true;
  if (typeof window.CustomEvent !== "function") return true;
  const event = new window.CustomEvent(NAVIGATION_INTENT_EVENT, {
    cancelable: true,
    detail,
  });
  return window.dispatchEvent(event);
}
